import SwitchAccount from './svg/SwitchAccount.svg'

export default SwitchAccount
